import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    authUserData: {},
  }
const signUpSlice = createSlice({
  name: 'authUser',
  initialState,
  reducers: {
    addUserData: (state, action) => {
      state.authUserData = action.payload;
    },
    reset: (state) => {
      state.authUserData = {};
    },
  },
});

export const { addUserData, reset } = signUpSlice.actions;

export default signUpSlice.reducer;